import PropTypes from 'prop-types';

const FormActions = ({ children, className = '' }) => (
	<div className={`q-form-actions${className ? ` ${className}` : ''}`}>{children}</div>
);

FormActions.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

export default FormActions;
